import {client} from 'utils/algolia';
import {locationUpdate} from 'actions';
import {HITS_PER_PAGE} from '../settings';

export const SEARCH_FOR_SET_NEW_QUERY = 'SEARCH_FOR_SET_NEW_QUERY';
export const SEARCH_FOR_SET_RESULTS = 'SEARCH_FOR_SET_RESULTS';

export function searchForSet(query, index) {
  const hitsPerPage = HITS_PER_PAGE;

  return (dispatch) => {
    dispatch(locationUpdate({
      query: {
        q: query,
      },
    }));

    dispatch({
      type: SEARCH_FOR_SET_NEW_QUERY,
      query,
    });

    client()
      .initIndex(index)
      .search(query, {hitsPerPage})
      .then((results) => {
        dispatch({
          type: SEARCH_FOR_SET_RESULTS,
          query,
          hits: results.hits,
          hitsPerPage,
          count: results.nbHits,
        });
      });
  };
}

export function navigateToSet(iconSetSlug) {
  location.assign(`/sets/${iconSetSlug}`);

  return (dispatch) => {};
}



// WEBPACK FOOTER //
// ./app/javascript/views/Sets/actions/index.js